import { render, staticRenderFns } from "./WhatsAppChat.vue?vue&type=template&id=ee21d420&scoped=true"
import script from "./WhatsAppChat.vue?vue&type=script&lang=js"
export * from "./WhatsAppChat.vue?vue&type=script&lang=js"
import style0 from "./WhatsAppChat.vue?vue&type=style&index=0&id=ee21d420&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ee21d420",
  null
  
)

export default component.exports